/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function pay(params, content) {
    var formatInput = function (options) { return ({
        url: options.payStr,
    }); };
    // TODO 淘宝支付环境待测试
    content === null || content === void 0 ? void 0 : content.WVCall('TBWVPayPasswrdValidateHandler.checkPayPasswordAction', params, {
        formatInput: formatInput,
    });
}

export { pay as default };
